import client from "./client";

export const fetchGallery = async () =>{
    const response = await client.get("gallery?per_page=100&page=1")
    return response.data;

};